import main from './main.vue'
const commonPaginationV4 = {
  install:function(Vue) {
    Vue.component(main.name, main)
  }
}
// 导出该组件
export default commonPaginationV4